import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
	{ field: 'id', headerName: 'ORDER ID', width: 150 },
	{
		field: 'depart',
		headerName: 'DEPART FROM',
		width: 150,
		editable: true,
	},
	{
		field: 'journey',
		headerName: 'JOURNEY TO',
		width: 150,
		editable: true,
	},
	{
		field: 'dob',
		headerName: 'DATE OF BOOKING',
		type: 'number',
		width: 150,
		editable: true,
	},
	{
		field: 'journeydate',
		headerName: 'JOURNEY DATE',
		description: 'This column has a value getter and is not sortable.',
		width: 160,
		type: 'number',
		editable: true,
	},
	{
		field: 'cost',
		headerName: 'TICKET COST',
		type: 'number',
		width: 150,
		editable: true,
	},
	// {
	// 	field: 'age',
	// 	headerName: 'ACTION',
	// 	type: 'number',
	// 	width: 150,
	// 	editable: true,
	// },
];

const rows = [
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456896',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456897',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456898',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456899',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456885',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456886',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456887',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456888',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
];

export default function DataGridD() {
	return (
		<Box sx={{ height: 400, width: '100%' }}>
			<DataGrid
				rows={rows}
				columns={columns}
				initialState={{
					pagination: {
						paginationModel: {
							pageSize: 5,
						},
					},
				}}
				pageSizeOptions={[5]}
				checkboxSelection
				disableRowSelectionOnClick
			/>
		</Box>
	);
}
